// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XG0h","content":"styles_content__21gbD"};